// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"et-z","giftOrPromoSelector":"ft-z","disabled":"gt-z","subTitle":"ht-z","selectShipAddressMessage":"it-z","changePayment":"jt-z"};